import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {formatTime} from "@/helper/method";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {permScope} from "@/helper/constant";
import {useAuthInfo} from "@/store/account.c";
import {useQueryUserPage, UserPageVO} from "@/service/user.s";
import {ViewUser} from "@/pages/User/ViewUser";
import Chip from "@mui/material/Chip";
import {AuthButtonVO} from "@/service/menu.s";
import {DeptTreeVO, useQueryDeptTree} from "@/service/dept.s";

export const DeptListPage = () => {
    const {
        mutate: userPageMutate,
        data: userPageData,
        isPending: userPagePending,
    } = useQueryUserPage()
    const {data: deptTreeData, isLoading, refetch} = useQueryDeptTree()
    const deptTree = deptTreeData?.data || []
    const {role: {dataScope}} = useAuthInfo()

    const columns: GridColDef<DeptTreeVO>[] = [
        {
            field: "deptName",
            headerName: "部门名称",
            flex: 0.28
        },
        // {
        //     field: "category",
        //     headerName: "部门类型",
        //     flex: 0.3
        // },
        {
            field: "leader",
            headerName: "部门负责人",
            headerAlign: "center",
            align: "center",
            flex: 0.3
        },
        {
            field: "sort",
            headerName: "排序",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
        },
        {
            field: "remark",
            headerName: "备注",
            headerAlign: "center",
            align: "center",
            flex: 0.3,
        },
        {
            field: "createdAt",
            headerName: "创建时间",
            headerAlign: "center",
            flex: 0.3,
            align: "center",
            valueFormatter: (value) => formatTime("D", value),
        },
    ];

    return (
        <ProTable<DeptTreeVO>
            columnVisibilityModel={{seller: dataScope !== permScope['self']}}
            loading={userPagePending}
            renderDrawer={{view: <ViewUser/>}}
            columns={columns}
            source={{
                dataSource: {
                    getRows: async () => {
                        return {rows: deptTree || [], rowCount: deptTree?.length}
                    }
                }
            }}
            // data={userPageData?.data}
            onSearch={(params) => {
                userPageMutate({...params});
            }}
            code={"dept"}
        />
    );
};
